import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-4edffb2c")
const _hoisted_1 = ["src", "srcset", "alt", "loading", "decoding", "width", "height"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("img", {
    src: _ctx.src,
    srcset: `${_ctx.src} 1x, ${_ctx.src2x} 2x`,
    alt: _ctx.alt,
    loading: _ctx.loading,
    decoding: _ctx.decodingStatus,
    width: _ctx.width,
    height: _ctx.height
  }, null, 8, _hoisted_1))
}